// extracted by mini-css-extract-plugin
module.exports = {"priceISectionItemList":"PriceISectionItemList_priceISectionItemList__2Dj1V","priceSectionItem":"PriceISectionItemList_priceSectionItem__26GrW"};